import { render, staticRenderFns } from "./seekAdviceFrom.vue?vue&type=template&id=426250fc&scoped=true&"
import script from "./seekAdviceFrom.vue?vue&type=script&lang=js&"
export * from "./seekAdviceFrom.vue?vue&type=script&lang=js&"
import style0 from "./seekAdviceFrom.vue?vue&type=style&index=0&id=426250fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426250fc",
  null
  
)

export default component.exports